import type { DialogueItem } from "@/types/content";

export default function DialogueThread({ dialogues }: { dialogues: DialogueItem[] }) {
  return (
    <div className="mt-6 flex flex-col gap-4">
      {dialogues.map((item, index) => {
        const isRight = item.side === "right";
        return (
          <div
            key={`${item.speaker}-${index}`}
            className={`flex flex-col ${isRight ? "items-end" : "items-start"}`}
          >
            <span className="mb-1.5 px-1 text-xs text-foreground-500">{item.speaker}</span>
            <p
              className={`max-w-[85%] rounded-lg px-4 py-3 text-sm leading-relaxed md:max-w-[75%] ${
                isRight
                  ? "rounded-tr-none bg-primary-500 text-background-50"
                  : "rounded-tl-none border border-background-200 bg-background-100 text-foreground-800"
              }`}
            >
              {item.text}
            </p>
          </div>
        );
      })}
    </div>
  );
}